// import arFLag from '../../assets/images/ar-flag.svg';
import enFLag from '../../assets/images/uk.svg';
import { currentLocale } from '../../redux/MalaebSlice/malaeb';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import Locale from './LanguageSwitcher.locale';

export default function LanguageSwitcher() {
  const { locale, country: selected_country } = useSelector((state) => state.malaeb);
  const dispatch = useDispatch();
  
  useEffect(() => {

    setTimeout(() => {
      dispatch({ type: "setLoading", payload: false });
    }, 500)
  }
    , [locale]);
  let arFLag = selected_country.code

  return (
    <UncontrolledDropdown className="lang-dropdown" style={{ minWidth: "auto" }}>
      <DropdownToggle caret className="btn-light">
        <img
          className="img-lang px-2"
          src={locale === 'ar' ? (`./images/flags/${arFLag}.svg`) : enFLag}
          width="40"
          alt="lang"
        />
        {Locale[locale]}
      </DropdownToggle>

      <DropdownMenu>
        <DropdownItem
          onClick={() => {
            if (currentLocale === 'ar') {
              dispatch({ type: 'setLocale', payload: 'en' });
              dispatch({ type: "setLoading", payload: true });
            }
          }}
        >
          <img className="img-lang" src={enFLag} width="20" alt="lang" />
          <span className={`${locale === 'en' ? 'ml-2' : 'mr-2'}`}>
            English
          </span>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            if (locale === 'en') {
              dispatch({ type: 'setLocale', payload: 'ar' });
              dispatch({ type: "setLoading", payload: true });
            }
          }}
        >
          <img className="img-lang" src={`./images/flags/${arFLag}.svg`} width="20" alt="lang" />
          <span className={`${locale === 'en' ? 'ml-2' : 'mr-2'}`}>العربية</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
